import { Messages } from '../../codegen/Localize';
import { SiteRoles } from '../../userManagement/users/serverApi/types/ISiteRole';
import { UserCategory } from '../../userManagement/users/serverApi/types/UserCategory';

export namespace SiteRolesHelper {
  export function siteRoleToName(siteRole: string): string {
    switch(siteRole) {
      case SiteRoles.ServerAdministrator: return Messages.siteRole_ServerAdministrator();
      case SiteRoles.SiteAdministratorCreator: return Messages.siteRole_SiteAdministratorCreator();
      case SiteRoles.SiteAdministratorExplorer: return Messages.siteRole_SiteAdministratorExplorer();
      case SiteRoles.SupportUser: return Messages.siteRole_SupportUser();
      case SiteRoles.Creator: return Messages.siteRole_Creator();
      case SiteRoles.ExplorerCanPublish: return Messages.siteRole_ExplorerCanPublish();
      case SiteRoles.Explorer: return Messages.siteRole_Explorer();
      case SiteRoles.Viewer: return Messages.siteRole_Viewer();
      case SiteRoles.Unlicensed: return Messages.siteRole_Unlicensed();
      case SiteRoles.Guest: return Messages.siteRole_Guest();
      default:
        return Messages.groupGrantRoleNotSet();
    }
  }

  export function siteRoleToIntegrationName(siteRole: string): string {
    switch(siteRole) {
      case SiteRoles.SiteAdministratorCreator: return Messages.siteRole_IntegrationAdmin();
      case SiteRoles.Creator: return Messages.siteRole_IntegrationCreator();
      case SiteRoles.Explorer: return Messages.siteRole_IntegrationExplorer();
      case SiteRoles.Viewer: return Messages.siteRole_IntegrationViewer();
      default:
        return siteRoleToName(siteRole);
    }
  }

  export function siteRoleToDisplayName(siteRole: string, userCategory?: UserCategory): string {
    if (userCategory === UserCategory.Integration) {
      return siteRoleToIntegrationName(siteRole);
    }
    return siteRoleToName(siteRole);
  }
}
